export const THEME_STORAGE_KEY = 'nivora-theme';
export const THEME_STORAGE_VERSION_KEY = 'nivora-theme-version';
export const THEME_STORAGE_VERSION = '2';
export const THEME_VALUES = Object.freeze(['dark', 'light']);
export const DEFAULT_THEME = 'light';

export function normalizeTheme(value) {
  return THEME_VALUES.includes(value) ? value : DEFAULT_THEME;
}

export function readStoredTheme(storage = typeof window !== 'undefined' ? window.localStorage : null) {
  try {
    if (storage?.getItem(THEME_STORAGE_VERSION_KEY) !== THEME_STORAGE_VERSION) {
      return DEFAULT_THEME;
    }
    return normalizeTheme(storage?.getItem(THEME_STORAGE_KEY));
  } catch (_error) {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme, documentRef = typeof document !== 'undefined' ? document : null) {
  const normalized = normalizeTheme(theme);
  if (!documentRef?.documentElement) return normalized;
  documentRef.documentElement.dataset.theme = normalized;
  documentRef.documentElement.style.colorScheme = normalized;
  return normalized;
}

export function persistTheme(theme, storage = typeof window !== 'undefined' ? window.localStorage : null) {
  const normalized = normalizeTheme(theme);
  try {
    storage?.setItem(THEME_STORAGE_KEY, normalized);
    storage?.setItem(THEME_STORAGE_VERSION_KEY, THEME_STORAGE_VERSION);
  } catch (_error) {
    // A preferência visual não deve impedir o carregamento do ERP.
  }
  return normalized;
}
